import { BaseEntity } from 'yt-ng-framework';

export class OsnovZaPravoNaGoView extends BaseEntity {
  constructor() {
      super();
  }
  OsnovZaGo: string = null;
  BrojDana: number = null;


  Deserialize(input: any) {
      this.ID = input.ID;
      this.OsnovZaGo = input.OsnovZaGo;
      this.BrojDana = input.BrojDana;
      return this;
  }

  Serialize(input: OsnovZaPravoNaGoView) {
      return input;
  }
}
